<template>
  <ui-section :semantic="true" :bgImage="bg" id="home" class="flex items-center">
    <div class="text-center text-3xl font-extralight">
      <div class="welcome">
        <h1 class="mt-8">{{ t('greeting', { name: userStore.user?.name ?? '' }) }}</h1>
        <p class="mt-1">{{ t('greeting_second') }}</p>
      </div>
    </div>

    <div class="main-grid mb-8 mt-8 text-center">
      <RouterLink to="/apps" class="card-link text-3xl">
        <div class="card">
          <IconApps />
        </div>
        <span class="pt-4">{{ t('apps') }}</span>
      </RouterLink>
      <a href="/video" class="card-link text-3xl">
        <div class="card">
          <IconVideo />
        </div>
        <span class="pt-4">{{ t('video') }}</span>
      </a>
      <RouterLink to="/material" class="card-link text-3xl">
        <div class="card">
          <IconMaterial />
        </div>
        <span class="pt-4">{{ t('material') }}</span>
      </RouterLink>
      <RouterLink to="/patients" class="card-link text-3xl">
        <div class="card">
          <IconPatient />
        </div>
        <span class="pt-4">{{ t('patients') }}</span>
      </RouterLink>
    </div>
  </ui-section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/user'
import UiSection from '@/components/ui/UiSection.vue'
import bg from '@/assets/img/home-background.png'

import IconApps from '@/assets/icons/apps_icon.svg'
import IconVideo from '@/assets/icons/videotherapy_icon.svg'
import IconMaterial from '@/assets/icons/material_icon.svg'
import IconPatient from '@/assets/icons/patient_icon.svg'

const { t } = useI18n()
const userStore = useUserStore()
</script>

<i18n>
{
  "de": {
    "greeting": "Hallo, {name}!",
    "greeting_second": "Willkommen in deinem digitalen Therapieraum.",
    "apps": "Apps",
    "video": "Videotherapie",
    "material": "Material",
    "patients": "Patient:innen"
  },
  "en": {
    "greeting": "Hello, {name}!",
    "greeting_second": "Welcome in your digital therapists office.",
    "apps": "Apps",
    "video": "Online Consultation",
    "material": "Material",
    "patients": "Patients"
  }
}
</i18n>

<style scoped lang="scss">
#home {
  min-height: calc(100vh - 125px);

  .main-grid {
    background-color: color-mix(in srgb, var(--background) 60%, transparent);
    border-radius: 1rem;
    padding: 4rem 5rem 2rem 5rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 4rem;

    .card-link {
      transition: 0.2s ease-in-out;
      &:hover {
        transform: scale(1.1);
      }
      .card {
        aspect-ratio: 1 / 1;
        width: 100%;
        background: var(--app-blue);
        border-radius: 0.99rem;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 0.2s ease-in-out;

        img {
          width: 50%;
        }
      }
      span {
        display: block;
      }
    }
  }
}
</style>
